import FJAIImageListContainer from '../../../../common/combineComponents/FJAIImageListContainer/container/FJAIImageListContainer';
import FJTextarea from '../../../../common/components/FJTextarea/FJTextarea';
import FJLocalStore from '../../../../store/FJLocalStore';
import FJAppLeft from '../../../FJMainPreview/FJAppLeft/FJAppLeft';
import FJAiVideoDubInputContainer from '../container/FJAiVideoDubInputContainer';
import styles from './FJAiVideoDubLeft.module.less';
import FJGenerateButton from '../../../../common/components/FJGenerateButton/FJGenerateButton';
import PropTypes from 'prop-types';
import { AI_VIDEO_DUB_USE_CREDIT } from '../../../../redux/slices/FJSliceAiVideoDub';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller';
import FJLabeledSwitch from '../../../../common/components/FJLabeledSwitch/FJLabeledSwitch';

const FJAiVideoDubLeft = props => {
    const {
        prompts,
        removeOriginAudioActive,
        onChangePrompts,
        onChangeRemoveOriginAudio,
        onGenerate,
        taskStatus,
        isFree,
        useCredit,
        freeNumCreation,
        disable,
        videoInfo,
    } = props;

    return (
        <FJAppLeft className={styles.left_panel}>
            <FJVerticalScroller className={styles.left_panel_scroller}>
                <FJAiVideoDubInputContainer disable={disable} />

                <FJAIImageListContainer position={{ top: 108, left: 478 }} />

                <div className={styles.prompts}>
                    <div className={styles.prompts_title}>{FJLocalStore._('video-description')}</div>
                    <FJTextarea
                        className={styles.prompts_textarea}
                        text={prompts}
                        onChange={onChangePrompts}
                        maxLength={2000}
                        disabled={disable}
                        placeholder={FJLocalStore._('prompt-placeholder')}
                    />
                </div>

                <FJLabeledSwitch
                    title={FJLocalStore._('remove-origin-audio')}
                    onChange={onChangeRemoveOriginAudio}
                    active={removeOriginAudioActive}
                    disable={disable}
                    desc={FJLocalStore._('remove-origin-audio-desc')}
                />
            </FJVerticalScroller>

            <FJGenerateButton
                className={styles.generate_btn}
                taskStatus={taskStatus}
                onClick={onGenerate}
                isFree={isFree}
                useCredit={Math.max(useCredit, AI_VIDEO_DUB_USE_CREDIT)}
                freeNumCreation={freeNumCreation}
                isShowUsageDetail={videoInfo && videoInfo.src ? true : false}
            />
        </FJAppLeft>
    );
};

FJAiVideoDubLeft.propTypes = {
    prompts: PropTypes.string,
    removeOriginAudioActive: PropTypes.bool,
    onChangePrompts: PropTypes.func,
    onChangeRemoveOriginAudio: PropTypes.func,
    onGenerate: PropTypes.func,
    taskStatus: PropTypes.string,
    isFree: PropTypes.bool,
    useCredit: PropTypes.number,
    freeNumCreation: PropTypes.number,
    disable: PropTypes.bool,
    videoInfo: PropTypes.object,
};

export default FJAiVideoDubLeft;
